import { LOGO_BG_COLORS } from '../../../view/react_components/base/components/Logo/components/constants';

export const getBoardLogoColorNew = (
): string => {
    const index = Math.floor(Math.random() * (LOGO_BG_COLORS.length));
    return LOGO_BG_COLORS[index];
}
